import { ImagenProducto } from '../types/producto.types';

export function validarImagenes(imagenes: ImagenProducto[]): string[] {
  const errores: string[] = [];

  if (imagenes.length > 5) {
    errores.push('Máximo 5 imágenes permitidas');
  }

  const totalTamano = imagenes.reduce((sum, img) => sum + img.tamaño, 0);
  if (totalTamano > 50 * 1024 * 1024) {
    errores.push('Tamaño total de imágenes excede 50 MB');
  }

  const tiposValidos = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];
  imagenes.forEach((img) => {
    if (!tiposValidos.includes(img.tipo)) {
      errores.push(`Tipo de imagen no permitido: ${img.tipo}`);
    }
  });

  return errores;
}
